/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: InstantLink.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  01.02.23 5:15 pm.
 * Last modified: 01.02.23 5:15 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React, { useEffect, useRef } from 'react';
import { addBuildHash, getGamesMinDenomination, updateResizables } from '../../api/helpers';
import { useSettings } from '../../contexts/SettingsContext';
import { useCustomInView } from '../../hooks/useCustomInView';
import useJackpotHoverPopup from '../../hooks/useJackpotHoverPopup';
import JackpotLevelValue from './JackpotLevelValue';

const InstantLinkJackpot = () => {
    const refLevel1 = useRef(null);
    const [jackpotRef, isVisible] = useCustomInView();

    const [settings] = useSettings();

    useEffect(() => {
        if (isVisible && refLevel1.current) {
            updateResizables(refLevel1.current);
        }
    }, [isVisible]);

    const currency = settings.currency;
    const sectionName = 'INSTANT';
    const instantLinkSection = settings.sections.find(section => section.name === sectionName);
    const denomination: number = getGamesMinDenomination(instantLinkSection?.games || [], settings.currency);

    const jackpotName = 'InstantLink';

    const [hoverHandlers, HoverComponent] = useJackpotHoverPopup({ jackpotName, denomination, currency });

    return (
        <div className="jp_instant_values" ref={jackpotRef}>
            <img
                src={addBuildHash(`${settings.host}/assets/portal/group_instant/grand.png`)}
                id={`instant_level1_placeholder_${sectionName}`}
                className={`instant_level1_placeholder`}
                alt=""
                data-ratio="0.2"
            />
            <div
                className={`resizable`}
                data-target={`instant_level1_placeholder_${sectionName}`}
                data-text-align="center"
                ref={refLevel1}
            >
                <div className={`jp_instant_counter jp_instant_numbers jp_instant_level1`} {...hoverHandlers(1)}>
                    <JackpotLevelValue jackpotName={jackpotName} denomination={denomination} level={1} />
                    <span className="jp_instant_currency">{currency}</span>
                </div>
            </div>
            <HoverComponent level={1} />
        </div>
    );
};

export default InstantLinkJackpot;
